













import Vue from "vue";
import { FeatureItem } from "./FeatureCard.vue";
import FeatureCard from "./FeatureCard.vue";

export default Vue.extend({
  name: "FeatureGroup",
  components: {
    FeatureCard,
  },
  props: {
    // Tối đa 3 features
    featureList: Array as () => FeatureItem[],
  },
});
